import { messages as maintainanceItemMessages } from '../views/inspection/maintainanceItemLang'
import { messages as maintainanceStandardManageMessages } from '../views/inspection/maintainanceStandardManageLang'
import { messages as maintainanceStandardItemMessages } from '../views/inspection/maintainanceStandardItemLang'
import { messages as maintainancePlanManageMessages } from '../views/inspection/maintainancePlanManageLang'
import { messages as addMaintainancePlanMessages } from '../views/inspection/addMaintainancePlanLang'
import { messages as editMaintainancePlanMessages } from '../views/inspection/editMaintainancePlanLang'
import { messages as maintainancePlanMachineMessages } from '../views/inspection/maintainancePlanMachineLang'
import { messages as maintainanceTaskDetailsMessages } from '../views/inspection/maintainanceTaskDetailsLang'
import { messages as maintainanceTaskManageMessages } from '../views/inspection/maintainanceTaskManageLang'
import { messages as maintainanceTaskDetailViewMessages } from '../views/inspection/maintainanceTaskDetailViewLang'
import { messages as adminInspectionPlanMessages } from '../views/inspection/adminInspectionPlanLang'
import { messages as aInspectionPlanDetailMessages } from '../views/inspection/aInspectionPlanDetailLang'
import { messages as adminInspectionTaskMessages } from '../views/inspection/adminInspectionTaskLang'
import { messages as adminInspectionTaskDetailMessages } from '../views/inspection/adminInspectionTaskDetailLang'
import { messages as inspectionPointMessages } from '../views/inspection/inspectionPointLang'
import { messages as inspectionRouteMessages } from '../views/inspection/inspectionRouteLang'
import { messages as inspectionItemManageMessages } from '../views/inspection/inspectionItemManageLang'
import { messages as inspectionItemTitleManageMessages } from '../views/inspection/inspectionItemTitleManageLang'
import { messages as inspectionPlanMessages } from '../views/inspection/inspectionPlanLang'
import { messages as addInspectionPlanMessages } from '../views/inspection/addInspectionPlanLang'
import { messages as inspectionTaskMessages } from '../views/inspection/inspectionTaskLang'
import { messages as inspectionTaskDetailsMessages } from '../views/inspection/inspectionTaskDetailsLang'
import { messages as inspectionPlanDetailMessages } from '../views/inspection/inspectionPlanDetailLang'

export const messages = {
    en: {
        ...adminInspectionPlanMessages.en,
        ...aInspectionPlanDetailMessages.en,
        ...adminInspectionTaskMessages.en,
        ...adminInspectionTaskDetailMessages.en,
        ...maintainanceItemMessages.en,
        ...maintainanceStandardManageMessages.en,
        ...maintainanceStandardItemMessages.en,
        ...maintainancePlanManageMessages.en,
        ...addMaintainancePlanMessages.en,
        ...editMaintainancePlanMessages.en,
        ...maintainancePlanMachineMessages.en,
        ...maintainanceTaskDetailsMessages.en,
        ...maintainanceTaskManageMessages.en,
        ...maintainanceTaskDetailViewMessages.en,
        ...inspectionPointMessages.en,
        ...inspectionRouteMessages.en,
        ...inspectionItemManageMessages.en,
        ...inspectionItemTitleManageMessages.en,
        ...inspectionPlanMessages.en,
        ...addInspectionPlanMessages.en,
        ...inspectionTaskMessages.en,
        ...inspectionTaskDetailsMessages.en,
        ...inspectionPlanDetailMessages.en,
    },
    zh: {
        ...adminInspectionPlanMessages.zh,
        ...aInspectionPlanDetailMessages.zh,
        ...adminInspectionTaskMessages.zh,
        ...adminInspectionTaskDetailMessages.zh,
        ...maintainanceItemMessages.zh,
        ...maintainanceStandardManageMessages.zh,
        ...maintainanceStandardItemMessages.zh,
        ...maintainancePlanManageMessages.zh,
        ...addMaintainancePlanMessages.zh,
        ...editMaintainancePlanMessages.zh,
        ...maintainancePlanMachineMessages.zh,
        ...maintainanceTaskDetailsMessages.zh,
        ...maintainanceTaskManageMessages.zh,
        ...maintainanceTaskDetailViewMessages.zh,
        ...inspectionPointMessages.zh,
        ...inspectionRouteMessages.zh,
        ...inspectionItemManageMessages.zh,
        ...inspectionItemTitleManageMessages.zh,
        ...inspectionPlanMessages.zh,
        ...addInspectionPlanMessages.zh,
        ...inspectionTaskMessages.zh,
        ...inspectionTaskDetailsMessages.zh,
        ...inspectionPlanDetailMessages.zh,
    }

}